export interface ForumPost {
  id: string;
  author: {
    name: string;
    avatar: string;
    role: string;
  };
  category: string;
  title: string;
  content: string;
  image?: string;
  likes: number;
  comments: Comment[];
  timestamp: string;
  isLiked?: boolean;
}

export interface Comment {
  id: string;
  author: {
    name: string;
    avatar: string;
  };
  content: string;
  timestamp: string;
  likes: number;
}

export const forumCategories = [
  { id: 'general', name: 'Général', color: 'bg-orange-500' },
  { id: 'sport', name: 'Sport', color: 'bg-teal-600' },
  { id: 'events', name: 'Événements', color: 'bg-purple-500' },
  { id: 'bureau', name: 'Bureau', color: 'bg-blue-500' },
  { id: 'suggestions', name: 'Suggestions', color: 'bg-green-500' },
];

export const forumPosts: ForumPost[] = [
  {
    id: '1',
    author: {
      name: 'Amadou Diallo',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20african%20man%20portrait%20smiling%20business%20casual&width=100&height=100&seq=101',
      role: 'Membre',
    },
    category: 'sport',
    title: 'Tournoi de football inter-entreprises - Qui est partant ?',
    content: 'Salut la famille ! Le tournoi de football inter-entreprises approche. On cherche des joueurs motivés pour constituer une équipe compétitive. Niveau débutant à intermédiaire bienvenu ! Entraînements prévus les mardis et jeudis.',
    likes: 24,
    comments: [
      {
        id: 'c1',
        author: {
          name: 'Fatou Ndiaye',
          avatar: 'https://readdy.ai/api/search-image?query=professional%20african%20woman%20portrait%20smiling%20confident&width=100&height=100&seq=102',
        },
        content: 'Je suis partante ! Je joue milieu de terrain.',
        timestamp: 'Il y a 2 heures',
        likes: 5,
      },
      {
        id: 'c2',
        author: {
          name: 'Omar Sow',
          avatar: 'https://readdy.ai/api/search-image?query=african%20man%20portrait%20friendly%20smile%20casual&width=100&height=100&seq=103',
        },
        content: 'Moi aussi je veux rejoindre ! Gardien de but ici.',
        timestamp: 'Il y a 1 heure',
        likes: 3,
      },
    ],
    timestamp: 'Il y a 4 heures',
  },
  {
    id: '2',
    author: {
      name: 'Mariama Fall',
      avatar: 'https://readdy.ai/api/search-image?query=african%20woman%20portrait%20professional%20warm%20smile&width=100&height=100&seq=104',
      role: 'Membre actif',
    },
    category: 'events',
    title: 'Photos de la soirée de gala ASC 2025',
    content: 'Quelle soirée incroyable ! Voici quelques photos de nos moments préférés. Merci à tous pour votre participation et votre énergie. Rendez-vous l\'année prochaine !',
    image: 'https://readdy.ai/api/search-image?query=african%20corporate%20gala%20event%20elegant%20people%20celebrating%20warm%20lighting%20professional%20photography&width=800&height=500&seq=105',
    likes: 156,
    comments: [
      {
        id: 'c3',
        author: {
          name: 'Ibrahima Kane',
          avatar: 'https://readdy.ai/api/search-image?query=african%20man%20business%20portrait%20professional%20smile&width=100&height=100&seq=106',
        },
        content: 'Magnifiques photos ! La soirée était top.',
        timestamp: 'Il y a 30 minutes',
        likes: 8,
      },
    ],
    timestamp: 'Il y a 1 jour',
  },
  {
    id: '3',
    author: {
      name: 'Sophie Dieng',
      avatar: 'https://readdy.ai/api/search-image?query=african%20woman%20young%20professional%20portrait%20bright%20smile&width=100&height=100&seq=107',
      role: 'Membre',
    },
    category: 'suggestions',
    title: 'Idée : Créer un groupe de randonnée mensuel',
    content: 'Je propose de créer un squad de randonnée pour explorer les belles régions du Sénégal. Lac rose, Mbour, les collines de Thiès... Qui serait intéressé ?',
    likes: 42,
    comments: [],
    timestamp: 'Il y a 2 jours',
  },
  {
    id: '4',
    author: {
      name: 'Président ASC',
      avatar: 'https://readdy.ai/api/search-image?query=african%20man%20executive%20portrait%20professional%20suit%20confident&width=100&height=100&seq=108',
      role: 'Bureau',
    },
    category: 'bureau',
    title: 'Assemblée générale - 15 Avril 2025',
    content: 'Chers membres, l\'assemblée générale annuelle se tiendra le 15 avril 2025 à 18h au siège social. Ordre du jour : bilan d\'activité, élection du nouveau bureau, projets 2025-2026. Votre présence est vivement souhaitée.',
    likes: 89,
    comments: [
      {
        id: 'c4',
        author: {
          name: 'Aminata Ba',
          avatar: 'https://readdy.ai/api/search-image?query=african%20woman%20elegant%20portrait%20professional%20warm&width=100&height=100&seq=109',
        },
        content: 'Je serai présente !',
        timestamp: 'Il y a 5 heures',
        likes: 2,
      },
    ],
    timestamp: 'Il y a 3 jours',
  },
  {
    id: '5',
    author: {
      name: 'Khalil Mbaye',
      avatar: 'https://readdy.ai/api/search-image?query=african%20young%20man%20casual%20portrait%20friendly%20smile&width=100&height=100&seq=110',
      role: 'Membre',
    },
    category: 'general',
    title: 'Bienvenue aux nouveaux membres !',
    content: 'Un grand merci à tous ceux qui ont rejoint l\'ASC ce mois-ci. N\'hésitez pas à poser vos questions ici ou à venir nous voir lors des événements. La communauté vous accueille à bras ouverts !',
    likes: 67,
    comments: [],
    timestamp: 'Il y a 4 jours',
  },
];